/* eslint-disable */
import {cookieConsentKeys, cookieConsentValues, pixelEvents} from '../constants-enumerate';

/**
 * Contains a list of pixels that need to be trigger globally
 * once a specific event has been trigger.
 */

export default () => {
  const pixels = {
    conversion: '',
    prospect_registration: ''
  };

  if (localStorage.getItem(cookieConsentKeys.COOKIE_PREFERENCES) === cookieConsentValues.COOKIES_OPTOUT) {
    pixels[pixelEvents.LANDING] = `
    <!-- Facebook: PageView -->
    <script>
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,"script",
      "https://connect.facebook.net/en_US/fbevents.js");

      fbq('dataProcessingOptions', ['LDU']);
      fbq("init", "2126132117408629");
      fbq("track", "PageView");
    </script>
    <noscript><img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=2126132117408629&ev=PageView&noscript=1"
    /></noscript>
    <!-- End Facebook: PageView -->
  `;

  pixels[pixelEvents.CONVERSION] = `
    <!-- Facebook: Conversion -->
    <script>
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,"script",
      "https://connect.facebook.net/en_US/fbevents.js");

      fbq('dataProcessingOptions', ['LDU']);
      fbq("init", "2126132117408629");
      fbq("track", "CompleteRegistration");
      fbq("track", "Purchase");
    </script>
    <!-- End Facebook: Conversion -->

    <!-- Global site tag (gtag.js) - Google Ads: 782124098 -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=AW-782124098"></script>
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag("js", new Date());

      gtag("config", "AW-782124098");
    </script>
    <script>
      gtag("event", "conversion", {
          "send_to": "AW-782124098/0mcaCJrU-YsBEMKI-fQC",
          "transaction_id": ""
      });
    </script>
`;

  pixels[pixelEvents.PROSPECT_REGISTRATION] = `
    <!-- Facebook: Lead -->
    <script>
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,"script",
      "https://connect.facebook.net/en_US/fbevents.js");

      fbq('dataProcessingOptions', ['LDU']);
      fbq("init", "2126132117408629");
      fbq('track', 'Lead',{ value: 0, currency: '0', });
    </script>
    <!-- End Facebook: Lead -->
  `;
  }

  if (localStorage.getItem(cookieConsentKeys.COOKIE_PREFERENCES) === cookieConsentValues.COOKIES_DEFAULT) {
    pixels[pixelEvents.LANDING] = `
    <!-- Facebook: PageView -->
    <script>
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,"script",
      "https://connect.facebook.net/en_US/fbevents.js");

      fbq('dataProcessingOptions', []);
      fbq("init", "2126132117408629");
      fbq("track", "PageView");
    </script>
    <noscript><img height="1" width="1" style="display:none"
      src="https://www.facebook.com/tr?id=2126132117408629&ev=PageView&noscript=1"
    /></noscript>
    <!-- End Facebook: PageView -->
  `;

  pixels[pixelEvents.CONVERSION] = `
    <!-- Facebook: Conversion -->
    <script>
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,"script",
      "https://connect.facebook.net/en_US/fbevents.js");

      fbq('dataProcessingOptions', []);
      fbq("init", "2126132117408629");
      fbq("track", "CompleteRegistration");
      fbq("track", "Purchase");
    </script>
    <!-- End Facebook: Conversion -->

    <!-- Global site tag (gtag.js) - Google Ads: 782124098 -->
    <script async src="https://www.googletagmanager.com/gtag/js?id=AW-782124098"></script>
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag("js", new Date());

      gtag("config", "AW-782124098");
    </script>
    <script>
      gtag("event", "conversion", {
          "send_to": "AW-782124098/0mcaCJrU-YsBEMKI-fQC",
          "transaction_id": ""
      });
    </script>
`;

  pixels[pixelEvents.PROSPECT_REGISTRATION] = `
    <!-- Facebook: Lead -->
    <script>
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version="2.0";
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,"script",
      "https://connect.facebook.net/en_US/fbevents.js");

      fbq('dataProcessingOptions', []);
      fbq("init", "2126132117408629");
      fbq('track', 'Lead',{ value: 0, currency: '0', });
    </script>
    <!-- End Facebook: Lead -->
  `;
  }

  return pixels;
};
